// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rw-0";